import type { LucideIcon } from "lucide-react"
import {
  Calendar,
  FileText,
  Folder,
  FolderTree,
  GraduationCap,
  Dumbbell,
  Inbox,
  QrCode,
  Shield,
  Settings2,
  Users,
} from "lucide-react"

export type NavItem = {
  title: string
  url: string
  icon: LucideIcon
  description?: string
}

export type NavGroup = {
  label: string
  items: NavItem[]
}

export const NAV_GROUPS: NavGroup[] = [
  {
    label: "系统管理",
    items: [
      {
        title: "角色管理",
        url: "/role",
        icon: Shield,
      },
      {
        title: "用户管理",
        url: "/user",
        icon: Users,
      },
      {
        title: "字典管理",
        url: "/dict",
        icon: Settings2,
      },
    ],
  },
  {
    label: "人员",
    items: [
      {
        title: "客资管理",
        url: "/lead",
        icon: Inbox,
      },
      {
        title: "学生管理",
        url: "/student",
        icon: GraduationCap,
      },
    ],
  },
  {
    label: "领域与分类",
    items: [
      {
        title: "一级领域管理",
        url: "/domain-lv1",
        icon: Folder,
      },
      {
        title: "二级领域管理",
        url: "/domain-lv2",
        icon: FolderTree,
      },
      {
        title: "训练项目管理",
        url: "/training-project",
        icon: Dumbbell,
      },
    ],
  },
  {
    label: "训练管理",
    items: [
      {
        title: "训练计划管理",
        url: "/training-plan",
        icon: Calendar,
      },
      {
        title: "训练计划记录",
        url: "/training-record",
        icon: FileText,
      },
      {
        title: "学生上课记录",
        url: "/class-records",
        icon: FileText,
      },
      {
        title: "节假日管理",
        url: "/holidays",
        icon: Calendar,
      },
    ],
  },
  {
    label: "资源管理",
    items: [
      {
        title: "文件管理",
        url: "/file-assets",
        icon: FileText,
      },
      {
        title: "二维码管理",
        url: "/qr-codes",
        icon: QrCode,
      },
    ],
  },
]

export const NAV_ITEMS = NAV_GROUPS.flatMap((group) => group.items)

export const getNavItem = (pathname: string) =>
  NAV_ITEMS.find(
    (item) => pathname === item.url || pathname.startsWith(`${item.url}/`),
  )
